export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const parentWindow = { domain: 'http://localhost:8080' };
export const SCROLL_TOP = 'SCROLL_TOP';
export const RESIZE = 'RESIZE';



// WEBPACK FOOTER //
// ./app/utils/constants.js